
import { Vue, Component } from "vue-property-decorator";
import AuthService from "@/services/auth_service";
import { Roles } from "@/models/user/roles";
import { GenericError } from "@/services/error_service";

@Component
export default class Login extends Vue {
  protected email = "";
  protected password = "";
  protected error = "";
  protected Roles = Roles;
  protected show1 = false;
  protected authService = new AuthService();

  created() {
    this.checkAuth();
  }

  public async handleLogin(): Promise<void> {
    this.error = "";
    try {
      // Only the origin of the return URL is reported to the API as the app
      // the user logged into, so any path/query on it is dropped here.
      let returnUrl: string | null =
        (this.$route.query.returnURL as string) ?? null;
      if (returnUrl) {
        try {
          returnUrl = new URL(returnUrl).origin;
        } catch (err) {
          returnUrl = null;
        }
      }
      const user: any = await this.authService.login(
        this.email,
        this.password,
        returnUrl
      );
      if (this.$route.query.returnURL) {
        const returnURL = this.$route.query.returnURL as string;
        const separator = returnURL.includes("?") ? "&" : "?";
        window.location.href = returnURL + separator + "redirect=true";
      } else {
        this.$router.push({
          name: "LoggedIn",
          params: {
            user: user,
          },
        });
      }
    } catch (err) {
      if (!err.message || err.statusCode == 500) {
        this.error =
          "Login failed. Please try again. If this message persists, please contact the administrator.";
      } else {
        this.error = err.message;
      }
    }
  }

  protected async checkAuth(): Promise<void> {
    try {
      const user: any = await this.authService.checkAuth();
      this.$router.push("/logged-in");
    } catch (err) {
      if (err.statusCode && err.statusCode == 500) {
        GenericError.popup("Something went wrong, please reload & try again.");
      }
    }
  }
}
